<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<div class="row">
  <div class="col-xl-3">
    <div class="w-100">
      <span class="font-weight-bold ">Time Range</span>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select [(ngModel)]="timeRange" (selectionChange)="timeRangeChanged()">
          <mat-option value="1">Year To Date</mat-option>
          <mat-option value="2">12 Months Rolling</mat-option>
          <mat-option value="3">Last 3 months</mat-option>
          <mat-option value="4">Month</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">Ending PO Receipt Month</span>
      <mat-form-field appearance="outline" class="w-100">
        <input matInput [owlDateTimeTrigger]="dt" [owlDateTime]="dt" [formControl]="dateTime" [max]="currentDate" readonly>
        <owl-date-time [pickerType]="'calendar'" [startView]="'multi-years'" (yearSelected)="chosenYearHandler($event)"
          (monthSelected)="chosenMonthHandler($event, dt)" #dt="owlDateTime"></owl-date-time>
      </mat-form-field>
    </div>
  </div>
  <div class="col-xl-3">
    <div class="w-100">
      <span class="font-weight-bold ">Consider Parent Supplier</span>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select [(ngModel)]="considerParentSupplier">
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">Consider Supplier-Commodity</span>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select [(ngModel)]="considerSupplierCommodity">
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">Consider Internal / External</span>
      <app-multiple-select [data]="considerInternalExternals" (result)="filterData('considerInternalExternal', $event)" [values]="considerInternalExternal"
         [reset]="reset" [defaultAll]="defaultAll">
      </app-multiple-select>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">Consider Complete / Non-complete</span>
      <app-multiple-select [data]="considerCompletes" (result)="filterData('considerComplete', $event)" [values]="considerComplete"
         [reset]="reset" [defaultAll]="defaultAll">
      </app-multiple-select>
    </div>
    <div class="w-100">
      <span class="font-weight-bold ">Limit To Spend</span>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select [(ngModel)]="topTotalSpend">
          <mat-option *ngFor="let item of limitToSpend" [value]="item.value" > {{ item.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="col-xl-3">
    <!-- <div class="w-100">
      <span class="font-weight-bold">Supplier Name</span>
      <app-search-input [data]="listParentSupplierGSL" (result)="filterData('parentSupplier', $event)"
        (searchKey)="considerParentChange($event)" [reset]="reset" [values]="parentNameGSLs">
      </app-search-input>
    </div> -->
    <div class="w-100" >
      <span class="font-weight-bold ">Parent Company Name</span>
      <app-lazyload-multiple-select [data]="parentNames" (result)="getGSL($event)" [values]="parents"
        [defaultAll]="true" [reset]="reset" [resetValue]="parents">
      </app-lazyload-multiple-select>
    </div>
    <div class="w-100" >
      <span class="font-weight-bold ">Supplier Name/GSL</span>
      <app-lazyload-multiple-select [data]="gslNumbers" (result)="filterData('gslNumber', $event)" [values]="parentNameGSLs"
        [defaultAll]="false" [reset]="reset" [resetValue]="parentNameGSLs">
      </app-lazyload-multiple-select>
    </div>
    <div class="w-100" >
      <span class="font-weight-bold ">Scorecard Class</span>
      <app-multiple-select [data]="scorecardClasses" (result)="filterData('scorecard', $event)" [values]="scorecardClass"
         [reset]="reset" [defaultAll]="defaultAll">
      </app-multiple-select>
    </div>
    <div class="w-100" >
      <span class="font-weight-bold ">Commercial Class</span>
      <app-multiple-select [data]="commercialClasses" (result)="filterData('commercial', $event)" [values]="commercialClass"
         [reset]="reset" [defaultAll]="defaultAll">
      </app-multiple-select>
    </div>
  </div>
  <div class="col-xl-3">
    <div class="w-100">
      <span class="font-weight-bold">Commodity</span>
      <app-multiple-select [data]="listCommodity" (result)="filterData('commodity', $event)" [reset]="reset"
      [values]="commodities" [defaultAll]="defaultAll">
      </app-multiple-select>
    </div>

    <div class="w-100" >
      <span class="font-weight-bold ">Minor Component</span>
      <app-lazyload-multiple-select [data]="minors" (result)="filterData('minor', $event)" [values]="minorComponent"
         [reset]="reset" [defaultAll]="defaultAll" [resetValue]="minors">
      </app-lazyload-multiple-select>
    </div>

    <div class="w-100">
      <span class="font-weight-bold">GE Location</span>
      <app-multiple-select [data]="listLocation" (result)="filterData('location', $event)" [reset]="reset"
      [values]="locations" [defaultAll]="defaultAll">
      </app-multiple-select>
    </div>

    <div class="w-100">
      <span class="font-weight-bold">Region</span>
      <app-multiple-select [data]="listRegion" (result)="filterData('region', $event)" [reset]="reset"
      [values]="regions" [defaultAll]="defaultAll">
      </app-multiple-select>
    </div>

    <div class="w-100" >
      <span class="font-weight-bold ">COE</span>
      <app-multiple-select [data]="coes" (result)="filterData('coe', $event)" [values]="coe"
         [reset]="reset" [defaultAll]="defaultAll">
      </app-multiple-select>
    </div>
  </div>
</div>
<div class="d-flex justify-content-end">
  <button class="btn btn-outline-primary btn-reset m-2" (click)="resetFilter()">Reset</button>
  <button class="btn button btn-primary m-2 btn-apply btn-vernova" (click)="apply()" [disabled]="!checkDisabledApplyButton()">Apply
    Filters</button>
</div>